<template>
  <div class="email-viewer">
    <div class="email-header mb-4">
      <div class="mb-3">
        <strong>De:</strong>
        <p class="text-muted">{{ email.from }}</p>
      </div>
      
      <div class="mb-3">
        <strong>Para:</strong>
        <p class="text-muted">{{ email.to }}</p>
      </div>

      <div class="mb-3">
        <strong>Status de Enfileiramento:</strong>
        <p class="text-muted">
          <span :class="email.enfileirado ? 'badge badge-success' : 'badge badge-warning'">
            {{ email.enfileirado ? 'Enfileirado' : 'Pendente' }}
          </span>
        </p>
      </div>

      <div class="mb-3">
        <strong>Tentativas de Envio:</strong>
        <p class="text-muted">{{ email.tentativas }}</p>
      </div>

      <div class="mb-3" v-if="email.sended_at">
        <strong>Enviado em:</strong>
        <p class="text-muted">{{ formatarData(email.sended_at) }}</p>
      </div>

      <div class="mb-3" v-if="email.log_falha">
        <strong>Log de Falha:</strong>
        <p class="text-danger">{{ email.log_falha }}</p>
      </div>

      <div class="mb-3">
        <strong>Data de Criação:</strong>
        <p class="text-muted">{{ formatarData(email.created_at) }}</p>
      </div>
    </div>

    <hr>

    <div class="email-body">
      <strong>Corpo do E-mail:</strong>
      <div class="email-content border p-3 mt-2" v-html="email.body"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisualizarEmailComponent',

  props: {
    email: {
      type: Object,
      required: true
    }
  },

  methods: {
    formatarData (data) {
      if (!data) return '-'
      
      const date = new Date(data)
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.email-viewer {
  max-height: 600px;
  overflow-y: auto;
}

.email-header {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
}

.email-content {
  background-color: #fafafa;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
  word-wrap: break-word;
}
</style>
